export enum ExtraParameterFieldType {
    TEXT = 1,
    SELECT_OPTION = 2,
    SELECT_MULTIPLE = 3
}